import { setStoreTypeValues } from "utils/setStoreTypeValues";

let types: any = {
  GET_POWERBI_TOKEN_REQUEST: "",
  GET_POWERBI_TOKEN_SUCCESS: "",
  GET_POWERBI_TOKEN_FAILURE: "",

  GET_POWERBI_PROVIDER_REQUEST: "",
  GET_POWERBI_PROVIDER_SUCCESS: "",
  GET_POWERBI_PROVIDER_FAILURE: "",
};

types = setStoreTypeValues(types, "powerBI");

export default types;
